var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.907715,
    y: 28.6108,
    width: 37,
    height: 37,
    transform: "rotate(-49.212 0.907715 28.6108)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_772_90938",
    transform: "scale(0.027027)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_772_90938",
    width: 37,
    height: 37,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAlCAMAAADyQNAxAAAASFBMVEUAAADovpbov5bov5Tfv4/pv5XmvpXpvpXnv5Ppv5fpv5fnvZXov5Tov5fnu5Ppv5bov5Xqvpbfv5/nvpfnv5Xov5bkupXov5Y6iiehAAAAF3RSTlMAgN8gEO9QcECvn2Awv0DPoI8QkGC/MIvHF9wAAAFjSURBVDjLlVTpmoMgDDThRjyqbuf933RLKaCyrd38CmTINzmG7mzyB052V3YDQJeoGYC/RNH7XMLo7PYA+nwYjdiBVH0/ArA1r6owgxoSAEJyQ7w2BWWB8koCkAnP8VofKYNTUAEJzjgXEuLV/HQZU2mcsqcqOT90GHJ6Fs1kbi8SM9yr1Hk5g2rdBIqp3/bWcqygh4nM1a64htzQaejOHyg15GaQgCW45RSglfrxLgs5AwPKQaF78qt4FJ5MTYMno0czgekeg45VCj1o4BvrhpyLnadNB63AxmpDfphQcsl1pc2KzNZgBRVeS7AbeVqaAbiAQPAfBCImsBihO/ehXyPHEfXoY++56X3d2C3PUQH0SYgz/Gt9b7KlBMBFb4Db71ezq/yseAIX+fJhV/VOHgrqzd4ntZw1pIoAK4qqCMVOgHTY0qrtqkFTaOSJ/flPaCP+8ee0zf36/1ovUdLhpyHzC3BVHkeAlNGzAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower);
export default __webpack_public_path__ + "static/media/flower.850e932de3bbbe7b639d664970786497.svg";
export { ForwardRef as ReactComponent };